import { MerchantPaymentConfig } from 'services/cos-service/models';

export const isICASupported = (merchantPaymentConfig: MerchantPaymentConfig | undefined) => {
  if (!merchantPaymentConfig?.ach?.supported) return false;
  const icaProducts = merchantPaymentConfig?.ach?.ach_products?.find(p => p.name === 'internet_check_acceptance')?.features;

  return icaProducts && icaProducts?.length > 0;
};
